<template>
    <svg class="svg" width="153" height="46" viewBox="0 0 153 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M133.029 1.78689L152.121 20.8788C153.293 22.0504 153.293 23.9498 152.121 25.1214L133.029 44.2133C131.858 45.3849 129.958 45.3849 128.787 44.2133C127.615 43.0417 127.615 41.1422 128.787 39.9707L142.757 26.0001L3 26.0001C1.34314 26.0001 -2.07618e-06 24.6569 -1.93133e-06 23.0001C-1.78649e-06 21.3432 1.34315 20.0001 3 20.0001L142.757 20.0001L128.787 6.02954C127.615 4.85796 127.615 2.95847 128.787 1.78689C129.958 0.615321 131.858 0.615321 133.029 1.78689Z"
            fill="url(#paint0_linear_4380_906)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_4380_906"
                x1="0"
                y1="23.0002"
                x2="150"
                y2="23.0002"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#32FFFF" />
                <stop offset="1" stop-color="#3CFF64" />
            </linearGradient>
        </defs>
    </svg>
</template>
